import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function SafetyTimers({ timers, onOpenIncident }) {
  const [busy, setBusy] = useState(null);
  if (!timers?.length) return null;
  const ack = async (t) => {
    setBusy(t.unit_id);
    try { await api.post(`/timers/${t.unit_id}/ack`); toast.success(`Check-in reminder for ${t.call_sign} acknowledged`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="fixed top-14 right-4 z-[900] space-y-2 w-[340px]" data-testid="safety-timers">
      {timers.map((t) => (
        <div key={t.unit_id} data-testid={`safety-timer-${t.call_sign}`} className="floating-card p-3 border-amber-500/50 fade-in">
          <div className="flex items-start gap-2">
            <BellRing className="h-4 w-4 text-amber-500 pulse-soft mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="overline-label text-amber-600 dark:text-amber-300">Safety check-in</div>
              <div className="text-sm font-medium">Check on <span className="mono font-semibold">{t.call_sign}</span> — {t.status_label} {t.elapsed_minutes}m (threshold {t.threshold_minutes}m)</div>
              <button data-testid={`safety-timer-open-${t.call_sign}`} onClick={() => onOpenIncident(t.incident_id)} className="text-[11px] text-primary hover:underline mono">{t.incident_number} · {t.call_type}</button>
            </div>
            <button data-testid={`safety-timer-ack-${t.call_sign}`} disabled={busy === t.unit_id} onClick={() => ack(t)} className="h-7 px-2 rounded-md border text-xs hover:bg-accent">Acknowledge / Reset</button>
          </div>
        </div>
      ))}
    </div>
  );
}
